<template>
  <section class="container-fluid team-experts-section py-5 bg-light" data-aos="fade-left" data-aos-duration="1200">
    <div class="container">
      <div class="row">
        <!-- Escalera de fotos -->
        <div class="col-lg-7 col-12 d-flex flex-column align-items-lg-start align-items-center">
          <h2 class="team-experts-title mb-2">{{ titles[selectedLang] }}</h2>
          <div class="team-escalera d-flex align-items-end justify-content-start w-100 position-relative">
            <div
              v-for="(member, idx) in orderedTeam"
              :key="member.id"
              :class="['team-photo-btn', { active: idx === team.length - 1 }]"
              @click="goToMember(getIdxByOrder(idx))"
              :style="photoStyle(idx)"
              :aria-label="member.name[selectedLang]"
            >
              <img :src="member.image || demoImg" :alt="member.name[selectedLang]" class="img-fluid" />
            </div>
          </div>
        </div>

        <!-- Tarjeta de información -->
        <div class="col-lg-5 col-12 d-flex flex-column align-items-lg-start align-items-center mt-4 mt-lg-0 ps-lg-5">
          <transition name="fade-slide" mode="out-in">
            <div class="team-card card p-4 shadow-sm" :key="activeMember.id">
              <div class="mb-1">
                <span class="team-card-name">{{ activeMember.name[selectedLang] }}</span>
              </div>
              <div class="team-card-position mb-2">{{ activeMember.position[selectedLang] }}</div>
              <div class="team-card-desc mb-4" v-html="activeMember.description[selectedLang]"></div>
              <div class="w-100 d-flex justify-content-end">
                <button class="btn btn-dark rounded-pill px-4 btn-sub" @click="nextMember" aria-label="Siguiente">
                  <span>&#8594;</span>
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { team } from '@/assets/data/data.ts';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default {
  name: "TeamSlides",
  props: {
    selectedLang: {
      type: String,
      default: 'es'
    }
  },
  data() {
    const demoImg = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdyiQXrWzEa2CGA4Dj4iRVj_qfWD-GKy7Cyg&s";
    const teamWithImg = team.map(m => ({ ...m, image: m.image || demoImg }));
    return {
      team: teamWithImg,
      currentIdx: 0,
      demoImg,
      titles: {
        es: "Nuestros Expertos",
        en: "Our Experts",
        de: "Unsere Experten"
      }
    };
  },
  computed: {
    orderedTeam() {
      const order = [];
      for (let i = 1; i <= this.team.length; i++) {
        order.push(this.team[(this.currentIdx + i) % this.team.length]);
      }
      return order;
    },
    activeMember() {
      return this.team[this.currentIdx];
    }
  },
  methods: {
    goToMember(idx) {
      this.currentIdx = idx;
    },
    getIdxByOrder(idx) {
      return (this.currentIdx + idx + 1) % this.team.length;
    },
    nextMember() {
      this.currentIdx = (this.currentIdx + 1) % this.team.length;
    },
    photoStyle(idx) {
      const minH = 120;
      const step = 42;
      const w = 120;
      const base = minH + idx * step;
      const z = idx;
      const isActive = idx === this.team.length - 1;
      return {
        height: `${base}px`,
        width: `${w}px`,
        marginLeft: idx === 0 ? '0' : '-18px',
        zIndex: z,
        opacity: isActive ? 1 : 0.78,
        border: isActive ? '2.5px solid #116687' : '2.5px solid #222',
        boxShadow: isActive ? '0 6px 24px #11668722' : '0 1px 10px #0001',
        cursor: isActive ? 'default' : 'pointer',
        transition: 'all .38s cubic-bezier(.7,.3,.3,1)'
      };
    }
  },
  mounted() {
    AOS.init({ duration: 800, once: true });
    setTimeout(() => AOS.refresh(), 300);
  }
};
</script>

<style scoped>
.team-experts-section {
  background: #f5faf9;
  min-height: 500px;
  position: relative;
}
.team-experts-title {
  font-size: 2.3rem;
  color: #1a2a2a;
  font-weight: 400;
  margin-left: 1rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  position: relative;
  display: inline-block;
}
.team-experts-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
}
.team-experts-title:hover::after {
  width: 100%;
}
.team-escalera {
  width: 100%;
  min-height: 270px;
  gap: 0;
  margin-left: 2vw;
}
.team-photo-btn {
  border-radius: 0;
  background: #fff;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 8px #0002;
  border: 2.5px solid #222;
  position: relative;
  transition: border-color 0.22s, box-shadow 0.22s, height .35s cubic-bezier(.7,.3,.3,1), opacity .24s;
}
.team-photo-btn.active {
  box-shadow: 0 10px 32px #11668722;
}
.team-photo-btn img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  filter: grayscale(.18) contrast(1.08);
}
.team-card {
  border: 2px solid #111;
  border-radius: 0;
  max-width: 410px;
  min-width: 250px;
  min-height: 460px;
  background: #fff;
  text-align: justify;
}
.team-card-name {
  font-size: 1.19rem;
  font-weight: bold;
  color: #222;
}
.team-card-position {
  font-size: 1.04rem;
  color: #116687;
  margin-bottom: 0.3rem;
}
.team-card-desc {
  font-size: 0.98rem;
  color: #222;
  white-space: pre-line;
}
.btn-sub {
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}
.btn-sub:hover {
  background-color: #2c74b8;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  color: #ffffff;
  border: 1px solid #2c74b8;
}
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.35s ease;
  position: relative;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* Responsive */
@media (max-width: 991.98px) {
  .team-experts-title { font-size: 1.5rem; margin-left: 0; }
  .team-escalera { margin-left: 0; }
  .team-photo-btn { min-width: 70px !important; min-height: 80px !important; }
}
@media (max-width: 767.98px) {
  .team-experts-section { min-height: 420px; }
  .team-experts-title { font-size: 1.2rem; }
  .team-escalera { min-height: 140px; justify-content: center; }
  .team-photo-btn { 
    min-width: 60px !important; 
    min-height: 70px !important; 
    opacity: 0.65; 
  }
  .team-photo-btn.active {
    opacity: 1;
    border: 2.5px solid #116687;
  }
  .team-card {
    max-width: 100%;
    min-width: 0;
    padding: 1rem !important;
    min-height: auto;
  }
}
</style>
